import axios from 'axios';
import type { BoardActiveContractWithRate } from '@bb/domain/dist/types';

export interface ActivationFeePrerequisites {
  canWaiveActivationFee: boolean;
  activeContracts: Partial<BoardActiveContractWithRate>[];
}

const getActivationFeePrerequisites = async ({
  orgId,
  orgType,
}: {
  orgId: string;
  orgType: 'brokerage' | 'mlsStaff';
}): Promise<ActivationFeePrerequisites> => {
  try {
    const { data } = await axios.get<ActivationFeePrerequisites>(
      `/supra/activation_fee_prerequisites/${orgId}/${orgType}`,
    );
    return data;
  } catch (error) {
    // Check for 404 error and return an empty array
    if (error.response && error.response.status === 404) {
      return { canWaiveActivationFee: false, activeContracts: [] };
    }
    throw error;
  }
};

export default getActivationFeePrerequisites;
